import React, {useState, useEffect} from "react"

function SuspectForm(props) {
    const [formInputs, setFormInputs] = useState({
        criminal: "NAME",
        routeCode: ""
    })
    const criminals = ["NAME", "Mary Floyd", "Tara Smythe", "Harriette Watts"]
    
    const [count, setCount] = useState(-1)
    const [, setFlash] = useState("")
    const [colorChange] = useState([
        "indianRed", 
        "burlywood",
        "indianRed",
        "burlywood",
        "indianRed",
        "burlywood",
        "indianRed",
        "burlywood"
    ])
    
    function handleChange(event) {
        const {id, value} = event.target
        setFormInputs({
            ...formInputs,
            [id]: [value]
        })
    }
    
    function submitAnswer() {
        const input = formInputs.criminal + " " + formInputs.routeCode
        
        if (input === props.correct) {
            console.log("correct answer")
            props.callBackSubmit(true)
        } else {
            setCount(0)
        }
    }
    
    useEffect(() => {
        if (count === 0) { 
            setFlash(() => setInterval(() => increaseFlashCount(), 250)) 
        } else if (count < colorChange.length) {
            document.getElementById("formInput").style.backgroundColor = colorChange[count]
        } else {
            document.getElementById("formInput").style.backgroundColor = "burlywood"
            setFormInputs({
                criminal: "NAME",
                routeCode: ""
            })
            setFlash(prevFlash => clearInterval(prevFlash))
        }
    }, [count, colorChange])
    
    function increaseFlashCount() {
        setCount(prevCount => prevCount + 1)
    }   
    
    const criminalOptions = criminals.map((value, index) => {
        return <option key={index} value={value}>{value}</option>
    })
    
    return (
        <div id="formInput">
            <h2>Our investigation concludes <select className="userAccusation" id="criminal" value={formInputs.criminal} onChange={handleChange}> {criminalOptions} </select> stole the Paradox Diamond!

            The route code was <input className="userAccusation" type="text" placeholder="ROUTE CODE" id="routeCode" maxLength="6" size="11" autoComplete="off" value={formInputs.routeCode} onChange={handleChange}/>.
            </h2>

            <button className="standardButton" onClick={submitAnswer}>Submit</button>
        </div>
    )
}

export default SuspectForm